import { render } from "./PlanPackageCompactJournal.vue?vue&type=template&id=79604806&ts=true"
import script from "./PlanPackageCompactJournal.vue?vue&type=script&lang=ts"
export * from "./PlanPackageCompactJournal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\BuildAgent\\work\\170657b851b0ad53\\Loading\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__